import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import "moment/locale/bg";
import MomentUtils from '@date-io/moment';
import { AppContext } from "../context/applicationContext";
import axios from 'axios';
import MenuItem from '@material-ui/core/MenuItem';
import deburr from 'lodash/deburr';
import Downshift from 'downshift';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import * as routes from '../constants/routes';
import { Redirect } from 'react-router-dom';
import Switch from '@material-ui/core/Switch';
import * as db from '../db/db';
import * as service from '../service/axiosImports';
import Spinner from '../shared/spinner';
import ArrowBackIos from '@material-ui/icons/ArrowBackIos';
import Save from '@material-ui/icons/Save';
const baseUrl = (process.env.PUBLIC_URL==='/'?'': process.env.PUBLIC_URL) ||'';

moment.locale("bg");

const env = process.env.NODE_ENV;
const now = moment();

const styles = theme => ({
    progress: {
        margin:theme.spacing(2),
        top: '50%!important',
        position: 'absolute'
    },
    container: {
        display: 'flex',
        flexGrow: 1,
        position: 'relative',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dense: {
        marginTop: 19,
    },
    menu: {
        width: 200,
    }, root: {
        flexGrow: 1,
        height: 250,
    },
    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing(1),
        left: 0,
        right: 0,
    },
    chip: {
        margin: `${theme.spacing(1) / 2}px ${theme.spacing(1) / 4}px`,
    },
    inputRoot: {
        flexWrap: 'wrap',
    },
    inputInput: {
        width: 'auto',
        flexGrow: 1,
    },
    divider: {
        height: theme.spacing(2),
    },
    buttonSuccess: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(0),
        width: '100%',
        color: 'white',
        backgroundColor: '#3a3f4b',
        justifyContent: 'center',
        backgroundColor: '#4cb34c'
    },
    buttonBack: {
        marginTop: theme.spacing(1),
        marginBottom:'10px',
        marginLeft: theme.spacing(0),
        width: '100%',
        color: 'white',
        backgroundColor: '#3a3f4b!important',
        justifyContent: 'center',
        backgroundColor: '#3a3f4b!important'
    },
    buttons: {
        // display: 'flex',
        justifyContent: 'flex-end',
    },
    customBtn: {
        backgroundColor: '#3a3f4b!important'
    }
});
const locale = 'bg';
class AddressForm extends Component {

    static contextType = AppContext;
    constructor(props) {
        super(props);
        this.state = {
            userId: null,
            employe: null,
            fromDate: null,
            toDate: null,
            errorMsg: false,
            fullName: '',
            holidayType: 'изберете',
            address: '',
            phone: '',
            desc: '',
            replacments: '',
            holidayTypeArr: [],
            suggestions:
                [
                    { label: 'Afghanistan', value: 'angel' },
                    { label: 'Aland Islands' }
                ],
            replacementUsers: [],
            daysBrake: 0,
            daysBrakeError: '',
            valid: false,
            ReplacementId: null,
            btnDisabled: false,
            redirect: false,
            progress: true,
            holidayTypeSwitch: true,
            validHealthBrake: false,
            redirectToList: false,
            lastHoliday: false,
            withProtocol: false,
            toDateButton: true,
            initialMaxDate:'',
            useAddedDays: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.getUserData = this.getUserData.bind(this);
        this.getHolidayType = this.getHolidayType.bind(this);
        this.handleChangeSelect = this.handleChangeSelect.bind(this);
        this.renderInput = this.renderInput.bind(this);
        this.getSuggestions = this.getSuggestions.bind(this);
        this.renderSuggestion = this.renderSuggestion.bind(this);
        this.handleSelectRep = this.handleSelectRep.bind(this);
        this.checkDates = this.checkDates.bind(this);
        this.validateReplacement = this.validateReplacement.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.changeState = this.changeState.bind(this);
    }

    componentDidMount() {
        if (this.context.userId !== null) {
            db.idbMethods.get(this.context.userId, db.userInfo).then((userInfo) => {
                if (userInfo.userId !== null && userInfo.userPrimaryCompany.companyURL !== null && userInfo.userId !== undefined 
                    && userInfo.userPrimaryCompany.companyURL !== undefined) {
                    this.setState({ userId: userInfo.userId, userSite: userInfo.userPrimaryCompany.companyURL });
                    this.getUserData(userInfo.userId, userInfo.userPrimaryCompany.companyURL);
                }
            });
            //this.getHolidayType();
        } else {
            this.logOut();
        }
        const currentDate = moment();
        const futureMonth = moment(currentDate).add(1, 'Y');
        this.setState({ initialMaxDate: futureMonth });
    }

    componentDidUpdate(prevProps) {
        if (this.context.userId !== this.state.userId) {
            this.setState({ userId: this.context.userId });
            db.idbMethods.get(this.context.userId, db.userInfo).then((userInfo) => {
                this.getUserData(userInfo.userId, userInfo.userPrimaryCompany.companyURL);
            });

            //this.getHolidayType();
        }
    }

    logOut = () => {
        this.context.setStateCustom('userId', null);
        db.idbMethods.clear(db.userInfo);
        db.idbMethods.clear(db.holidaysForApprove);
        db.idbMethods.clear(db.holidaysForApproveList);
        db.idbMethods.clear(db.myHolidays);
        this.setState({ redirect: true });
        setTimeout(() => {
          window.location = window.location;
        }, 100);
      }



    getUserData(id, siteUrl) {
        const link = baseUrl + '/api/getUserData';
        // const isExpire = service.axiosMethods.getNewToken(this.context.expireIn).then((getNew) => {
        // });

        axios.post(link, {
            "SiteUrl": siteUrl,
            "UserId": id
        }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                if (res.status === 200) {
                    let replacmentsArr = [];
                    res.data.Replacements.forEach(rep => {
                        replacmentsArr.push({ id: rep.UserID, label: rep.FullName });
                    });
                    this.setState({ fullName: res.data.FullName, employe: res.data, replacementUsers: replacmentsArr, progress: false });
                    this.getHolidayType(siteUrl);
                }
            }).catch(error => {
                console.log(error);
                var errorObj = JSON.parse(JSON.stringify(error));
                this.props.enqueueSnackbar(errorObj.response.data.errorMsg, { variant: "error" });
                this.setState({ redirect: true });
            })
    }

    getHolidayType(siteUrl) {
        const link = baseUrl + '/api/getHolidayType';
        axios.post(link, 
           // { "Url": "https://all4lirex.lirex.com/LirexBG/Nomenclatures", 
           // { "Url": "http://sf-spsdev08/sites/Holidays/LirexBG/Nomenclatures", 
            { "Url": siteUrl + "Nomenclatures", 
            "ColumnInternalName": "HolidayType",
            "UserId": this.context.userId,
            "UserPosition": this.state.employe?.UserPosition, 
            "DaysAdded": this.state.employe?.DaysAdded,
            "DisplayMode": "1"
        },
            { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                if (res.status === 200) {
                    let holidayArr = [{
                        value: 'изберете',
                        label: 'Моля изберете тип отпуск',
                    }];
                    res.data.forEach((element, i) => {
                        const value = '{"Type":"' + element.Type + '","SubType":"' + element.SubType + '"}';
                        holidayArr.push({
                            value: value,
                            label: element.SubType,
                            index: i
                        });
                    });

                    // this.context.setStateCustom('userId', res.data);
                    this.setState({ holidayTypeArr: holidayArr });

                }
            }).catch(error => {
                console.log(error);
                 if (errorObj.response.data.errorMsg != undefined && errorObj.response.data.errorMsg != ''){
                this.props.enqueueSnackbar(errorObj.response.data.errorMsg, { variant: "error" });
                 }
            })
    }

    validateReplacement(id) {
        this.setState({ progress: true });
        const link = baseUrl + '/api/validateReplacement';
        axios.post(link,
            {
                "SiteUrl": this.state.userSite,
                "Mode": 1,
                "dFrom": this.state.fromDate,
                "dTo": this.state.toDate,
                "CurrentUser": this.context.userId,
                "ReplacementUser": id,
                "ItemId": 0
            }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                if (res.status === 200) {
                    if (this.state.holidayType === 'изберете') {
                        this.props.enqueueSnackbar('Изберете тип отпуск.', { variant: "warning" });
                        this.setState({ valid: true, ReplacementId: id, btnDisabled: true });
                    } else {
                        this.setState({ valid: true, ReplacementId: id, btnDisabled: false });
                        this.props.enqueueSnackbar('Избраният заместник е свободен.', { variant: "success" });
                    }
                    this.setState({ progress: false });
                }
            }).catch(error => {
                console.log(error.response.data.errorMsg);
                this.setState({ valid: false, ReplacementId: null, btnDisabled: true });
                this.props.enqueueSnackbar(error.response.data.errorMsg, { variant: "error" });
                this.setState({ progress: false });
            })
    }

    checkDates() {
        const link = baseUrl + '/api/checkDates';
        axios.post(link,
            { "dFirst": this.state.fromDate, "dSecond": this.state.toDate, "SiteUrl": this.state.userSite }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                if (res.status === 200) {
                    if (res.data.days == 0) {
                        this.setState({ daysBrake: 0, daysBrakeError: '', fromDate: null, toDate: null });
                        this.props.enqueueSnackbar('Избраните дати са почивни дни или официални празници', { variant: "error" });
                    } else {
                        if (this.state.fromDate !== null && this.state.toDate !== null) {
                            this.setState({ btnDisabled: false });
                            this.setState({ toDateButton: false });
                        }
                        this.setState({ daysBrake: res.data.days, daysBrakeError: '', validHealthBrake: true });
                    }
                }
            }).catch(error => {
                var errorObj = JSON.parse(JSON.stringify(error));
                console.log(errorObj);
                this.setState({ daysBrake: 0, daysBrakeError: error.response.data.errorMsg, fromDate: null, toDate: null, toDateButton: true });
                this.props.enqueueSnackbar(errorObj.response.data.errorMsg, { variant: "error" });
            })
    }

    handleChange(target, date) {
        if(date === null){
            this.clearDates();         
        }else{
        this.setState({
            [target]: date
        })
        if (date !== null) {
            this.setState({ toDateButton: false });
        }
        setTimeout(() => {
            if (this.state.fromDate !== null && this.state.toDate !== null) {
                this.checkDates();
            }
        }, 100);
    }

    }

    clearDates(){
        this.setState({
            fromDate: null,toDate:null,toDateButton:true,daysBrake: 0, daysBrakeError: ''
        }); 
    }

    handleChangeSelect(target, e) {
        this.setState({ [target]: e.target.value });
        if (e.target.value !== 'изберете') {
            this.setState({ btnDisabled: false });
        }
    }

    handleSelectRep(selected) {
        const selectedRep = this.state.replacementUsers.filter(suggestion => {
            return suggestion.label === selected ? suggestion : null;
        });
        this.validateReplacement(selectedRep[0].id);
    }

    getSuggestions(value) {
        const inputValue = deburr(value.trim()).toLowerCase();
        const inputLength = inputValue.length;
        let count = 0;

        return inputLength === 0
            ? []
            : this.state.replacementUsers.filter(suggestion => {
                const keep =
                    count < 5 && suggestion.label.slice(0, inputLength).toLowerCase() === inputValue;

                if (keep) {
                    count += 1;
                }

                return keep;
            });
    }

    changeState(element,value){
        this.setState({[element]:value});
    }
    
    submitForm(e) {

        this.setState({ btnDisabled: true, progress: true });
        const link = baseUrl + '/api/submitForm';
        axios.post(link,
            {
                'Address': this.state.address,
                'DateFrom': this.state.fromDate,
                'DateTo': this.state.toDate,
                'Days': this.state.daysBrake,
                'Employee': this.state.employe,
                'Id': 0,
                'Mobile': this.state.phone,
                'ReplacementId': this.state.ReplacementId,
                'RequestorId': this.context.userId,
                'SiteUrl': this.state.userSite,
                'SubType': JSON.parse(this.state.holidayType).SubType,
                'Title': "1",
                'TotalAllowedDays': this.state.employe.Days,
                'TotalAllowedDaysNextYear': this.state.employe.DaysLeftNextYear,
                'TotalAllowedAddedDays': this.state.employe.DaysAdded,
                'Type': JSON.parse(this.state.holidayType).Type,
                'TypeRequest': "отпуск",
                'WantBlank': this.state.withProtocol
            }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                if (res.status === 200) {
                    this.props.enqueueSnackbar('Успешно създадена заявка за отпуск.', { variant: "success" });
                    if (JSON.parse(this.state.holidayType).SubType === 'допълнителен отпуск за стаж') {
                        const daysAdded = this.context.daysAdded - this.state.daysBrake;
                        this.context.setStateCustom('daysAdded', daysAdded);
                    } else {
                        const days = this.context.days - this.state.daysBrake;
                        this.context.setStateCustom('days', days);
                        db.idbMethods.getAll(db.userInfo).then((userInfo) => {
                            if (userInfo !== undefined && userInfo !== null && userInfo.length !== 0) {
                                var user = userInfo[0];
                                user.Days = days;
                                db.idbMethods.set(user, db.userInfo);
                                this.setState({ userInfo: user });
                            }
                        })
                    }

                    this.clear();
                    this.redirectToHolidaysList();
                }
            }).catch(error => {
                var errorObj = JSON.parse(JSON.stringify(error));
                console.log(error)
                //this.props.enqueueSnackbar(env === 'development' ? errorObj.response.data : errorObj.response.data.errorMsg, { variant: "error" });
                this.props.enqueueSnackbar(error.response.data.errorMsg, { variant: "error" });
                this.setState({ btnDisabled: true, progress: false });
            })
    }


    renderInput(inputProps) {
        const { InputProps, classes, ref, ...other } = inputProps;

        return (
            <TextField
                InputProps={{
                    inputRef: ref,
                    classes: {
                        root: classes.inputRoot,
                        input: classes.inputInput,
                    },
                    ...InputProps,
                }}
                {...other}
            />
        );
    }

    renderSuggestion({ suggestion, index, itemProps, highlightedIndex, selectedItem }) {
        const isHighlighted = highlightedIndex === index;
        const isSelected = (selectedItem || '').indexOf(suggestion.label) > -1;

        return (
            <MenuItem
                {...itemProps}
                key={suggestion.label}
                selected={isHighlighted}
                component="div"
                style={{
                    fontWeight: isSelected ? 500 : 400,
                }}
            >
                {suggestion.label}
            </MenuItem>
        );
    }

    handleChangeHolidayType = () => {
        this.clear();
        this.setState({ holidayTypeSwitch: !this.state.holidayTypeSwitch });
        this.setState({ lastHoliday: false });
        this.props.handleTypeChange(this.state.holidayTypeSwitch);

    }

    clear = () => {
        this.setState({
            fromDate: null,
            toDate: null,
            errorMsg: false,
            holidayType: 'изберете',
            address: '',
            phone: '',
            desc: '',
            replacments: '',
            replacementUsers: [],
            daysBrake: 0,
            daysBrakeError: '',
            valid: false,
            ReplacementId: null,
            btnDisabled: false,
            redirect: false,
            progress: false,
            validHealthBrake: false,
            holidayTypeSwitch: true,
            toDateButton: true
        });
    }

    getLastHoliday = () => {
        var holidayState = !this.state.lastHoliday;
        this.setState({ btnDisabled: true, progress: true });
        this.setState({ lastHoliday: holidayState});
        const link = baseUrl + '/api/GetLastHolidayByUser';
        if (holidayState){
        axios.post(link,
            {
                "UserId": this.context.userId,
                "UserPosition": this.state.employe.UserPosition,
                "SiteUrl": this.state.userSite
            }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                this.setState({ btnDisabled: true, progress: false, valid: false });
                if (res.status === 200) {
                    const value = '{"Type":"' + res.data.Type + '","SubType":"' + res.data.SubType + '"}';
                    this.setState({
                        holidayType: value,
                        address: res.data.Address !== null ? res.data.Address : '',
                        phone: res.data.Mobile !== null ? res.data.Mobile : '',
                        desc: res.data.Description !== null ? res.data.Description : '',
                        withProtocol: res.data.WantBlank !== null ? res.data.WantBlank : false
                    });
                }
            }).catch(error => {
                var errorObj = JSON.parse(JSON.stringify(error));
                this.props.enqueueSnackbar(errorObj.response.data.errorMsg, { variant: "error" });
                this.setState({ btnDisabled: true, progress: false, valid: false });
            })
        } else {
            this.clear();
        }
    }

    submitHealthForm = () => {
        this.setState({ btnDisabled: true, progress: true });
        const link = baseUrl + '/api/submitForm';
        axios.post(link,
            {
                'Address': null,
                'DateFrom': this.state.fromDate,
                'DateTo': this.state.toDate,
                'Days': this.state.daysBrake,
                'Employee': this.state.employe,
                'Description': this.state.desc,
                'Id': 0,
                'Mobile': null,
                'ReplacementId': 0,
                'RequestorId': this.context.userId,
                'SiteUrl': this.state.userSite,
                'SubType': null,
                'Title': "1",
                'TotalAllowedDays': this.state.employe.Days,
                'TotalAllowedDaysNextYear': this.state.employe.DaysLeftNextYear,
                'Type': null,
                'TypeRequest': "болничен",
                'WantBlank':this.state.withProtocol
            }, { headers: { 'Authorization': 'Bearer ' + this.context.token } })
            .then(res => {
                if (res.status === 200) {
                    this.props.enqueueSnackbar('Успешно създадена заявка за болничен.', { variant: "success" });
                    this.clear();
                    this.redirectToHolidaysList();
                }
            }).catch(error => {
                var errorObj = JSON.parse(JSON.stringify(error));
                this.props.enqueueSnackbar(error.response.data.errorMsg, { variant: "error" });
                this.setState({ btnDisabled: true, progress: false });
            })
    }

    redirectToHolidaysList = () => {
        this.setState({ redirectToList: true });
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={routes.HOME_LOGIN} />
        }
        if (this.state.redirectToList) {
            return <Redirect to={routes.MY_HOLIDAYS} />
        }
        const custStyles = {
            hr: {
                marginBottom: 40,
                height: 4,
                backgroundColor: 'black'
            },
            hr2: {
                marginTop: 20,
                height: 4,
                backgroundColor: 'black'
            },
            title: {
                fontWeight: 400
            }
        };
        const { classes } = this.props;
        const appClass = `${classes.appBar} ${this.state.progress ? 'pointer-none' : ''}`;
        const mainClass = `${this.state.progress ? 'pointer-none' : ''}`;
        return (
            <React.Fragment>
                {this.state.progress ? <Spinner></Spinner> : null}
                <div>
                    {/* <span className='black-color'>Болничен</span> */}
                    <Switch
                        checked={this.state.holidayTypeSwitch}
                        onChange={() => { this.handleChangeHolidayType() }}
                        color='primary'
                        value="checkedA"
                    />
                    <span className='black-color'>Отпуск</span>
                </div>
                {this.state.holidayTypeSwitch ? <div className={mainClass}>
                    {this.state.employe !== null ?
                        <span>
                            {/* <hr style={custStyles.hr2} />
                            <Grid item xs={12} sm={12}>
                                <Typography component="h4" variant="h6" className="days-brake">
                                    <span style={custStyles.title}>Дни отпуск</span>: {this.state.employe.Days}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography component="h6" variant="h5" className="days-brake">
                                    <span style={custStyles.title}>Длъжност</span>: {this.state.employe.UserPosition}
                                </Typography>
                            </Grid> */}
                            <Grid item xs={12} sm={12}>
                                <Switch
                                    checked={this.state.withProtocol}
                                    onChange={() => { this.changeState('withProtocol', !this.state.withProtocol)}}
                                    color="primary"
                                    value="checkedB"
                                    classes={{ checked: 'green-circle' }}
                                /> <span className='black-color'>Искам да получа чрез мейл бланка за разпечатване при одобрение</span>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                {/* <Button
                                    size="small"
                                    variant="contained"
                                    onClick={this.getLastHoliday}
                                    className={classes.customBtn}>
                                    Използвайте последния отпуск
                                        </Button> */}
                                {/* <Switch
                                    checked={this.state.lastHoliday}
                                    onChange={() => { this.getLastHoliday() }}
                                    color="primary"
                                    value="checkedA"
                                    classes={{ checked: 'green-circle' }}
                                /> <span className='black-color'>Използвайте данни от последния отпуск</span> */}
                                 <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => { this.getLastHoliday() }}
                            className={classes.buttonBack}
                        >
                            <span className='btn-content'>Използвайте последния отпуск</span>
                         </Button>
                            </Grid>
                            
                            {/* <hr style={custStyles.hr} /> */}
                            </span> : null}
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                required
                                id="firstName"
                                name="firstName"
                                label="Служител"
                                value={this.state.fullName}
                                fullWidth
                                autoComplete="fname"
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            {this.state.holidayTypeArr.length > 0 ?
                                <TextField
                                    id="standard-select-currency"
                                    select
                                    label="Тип отпуск*"
                                    fullWidth
                                    value={this.state.holidayType}
                                    onChange={(e) => this.handleChangeSelect("holidayType", e)}
                                    SelectProps={{
                                        MenuProps: {
                                            className: classes.menu,
                                        },
                                    }}
                                >  {this.state.holidayTypeArr.map(option => (
                                    <MenuItem id='menuItem' key={option.value} value={option.value} className="menuItem">
                                        {option.label}
                                    </MenuItem>
                                ))}
                                </TextField> : null}
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <MuiPickersUtilsProvider utils={MomentUtils} locale={locale}>
                                 <DatePicker required
                                        style={{ width: '100%' }}
                                        onChange={(date) => this.handleChange('fromDate', date)}
                                        margin="none"
                                        emptyLabel="(първият ден, в който не сте на работа)"
                                        label="Начална дата"
                                        value={this.state.fromDate}
                                        maxDate={this.state.toDate === null?this.state.initialMaxDate:this.state.toDate}
                                        format={'DD.MM.YYYY'}
                                        clearable={true}
                                        clearLabel='Изчисти'
                                        cancelLabel='Назад'
                                        okLabel='Избери'
                                    />
                                 
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <MuiPickersUtilsProvider utils={MomentUtils} locale={locale}>
                                <DatePicker required
                                    style={{ width: '100%' }}
                                    onChange={(date) => this.handleChange("toDate", date)}
                                    margin="none"
                                    name="toDate"
                                    emptyLabel="(последният ден, в който не сте на работа)"
                                    label="Крайна дата"
                                    value={this.state.toDate}
                                    format={'DD.MM.YYYY'}
                                    minDate={this.state.fromDate === null?'':this.state.fromDate}
                                    disabled={this.state.toDateButton}
                                    clearable={true}
                                    clearLabel='Изчисти'
                                    cancelLabel='Назад'
                                    okLabel='Избери'
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        {this.state.daysBrake !== 0 && this.state.daysBrakeError === '' ?
                            <Grid item xs={12} sm={12}>
                                <Typography component="h4" variant="h6" align="left" className="days-brake">
                                    Общо работни дни за отпуск: {this.state.daysBrake}
                                </Typography>
                            </Grid> : null}
                        {this.state.daysBrake === 0 && this.state.daysBrakeError !== '' ?
                            <Grid item xs={12} sm={12}>
                                <Typography component="h4" variant="h6" align="left" className="days-brake days-brake-error">
                                    {this.state.daysBrakeError}
                                </Typography>
                            </Grid> : null}
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="address1"
                                name="address1"
                                label="Адрес"
                                fullWidth
                                autoComplete="billing address-line1"
                                value={this.state.address}
                                onChange={(e) => this.handleChangeSelect("address", e)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="phone"
                                name="phone"
                                label="Телефонен номер"
                                fullWidth
                                autoComplete="billing address-line2"
                                value={this.state.phone}
                                onChange={(e) => this.handleChangeSelect("phone", e)}
                                placeholder='(пример: "0888123456")'
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                id="desc"
                                name="desc"
                                label="Описание"
                                fullWidth
                                autoComplete="billing address-level2"
                                value={this.state.desc}
                                onChange={(e) => this.handleChangeSelect("desc", e)}
                            />
                        </Grid>
                        {this.state.fromDate !== null && this.state.toDate !== null ?
                            <Grid item xs={12} sm={12}>
                                <Downshift id="downshift-simple" onSelect={(selectedItem) => this.handleSelectRep(selectedItem)}>
                                    {({
                                        getInputProps,
                                        getItemProps,
                                        getMenuProps,
                                        highlightedIndex,
                                        inputValue,
                                        isOpen,
                                        selectedItem,
                                    }) => (
                                            <div className={classes.container}>
                                                {this.renderInput({
                                                    fullWidth: true,
                                                    classes,
                                                    InputProps: getInputProps({
                                                        placeholder: '(пишете името му на кирилица)',
                                                    }),
                                                    label: 'Изберете заместник *',
                                                })}
                                                <div {...getMenuProps()}>
                                                    {isOpen ? (
                                                        <Paper className={classes.paper} square>
                                                            {this.getSuggestions(inputValue).map((suggestion, index) =>
                                                                this.renderSuggestion({
                                                                    suggestion,
                                                                    index,
                                                                    itemProps: getItemProps({ item: suggestion.label }),
                                                                    highlightedIndex,
                                                                    selectedItem,
                                                                }),
                                                            )}
                                                        </Paper>
                                                    ) : null}
                                                </div>
                                            </div>
                                        )}
                                </Downshift>
                            </Grid> : null}
                    </Grid>
                    <div className={classes.buttons}>
                        {this.state.valid ?
                            <span>
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    onClick={this.submitForm}
                                    className={classes.buttonSuccess}
                                    disabled={this.state.btnDisabled}
                                >
                                    <Save className='white-back-button customBtn'></Save>
                                    <span className='btn-content'>  Запис </span>
                            </Button>
                            </span> : null}
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => { this.redirectToHolidaysList() }}
                            className={classes.buttonBack}
                        >
                            <ArrowBackIos className='white-back-button customBtn'></ArrowBackIos>
                            <span className='btn-content'>Назад</span>
                         </Button>
                    </div>
                </div>
                    : <span className={mainClass}>
                        <Grid container spacing={1}>
                        <Grid item xs={12} sm={12}>
                                <Switch
                                    checked={this.state.withProtocol}
                                    onChange={() => { this.changeState('withProtocol', !this.state.withProtocol)}}
                                    color="primary"
                                    value="checkedB"
                                    classes={{ checked: 'green-circle' }}
                                /> <span className='black-color'>Искам да получа чрез мейл бланка за разпечатване при одобрение</span>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    required
                                    id="firstName"
                                    name="firstName"
                                    label="Служител"
                                    value={this.state.fullName}
                                    fullWidth
                                    autoComplete="fname"
                                />
                            </Grid>
                            
                            <Grid item xs={12} sm={12}>
                                <MuiPickersUtilsProvider utils={MomentUtils} locale={locale}>
                                        <DatePicker required
                                          style={{ width: '100%' }}
                                          onChange={(date) => this.handleChange('fromDate', date)}
                                          margin="none"
                                          emptyLabel="(първият ден, в който не сте на работа)"
                                          label="Начална дата"
                                          value={this.state.fromDate}
                                          maxDate={this.state.toDate === null?this.state.initialMaxDate:this.state.toDate}
                                          format={'DD.MM.YYYY'}
                                          clearable={true}
                                          clearLabel='Изчисти'
                                          cancelLabel='Назад'
                                          okLabel='Избери'
                                        />                                        
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <MuiPickersUtilsProvider utils={MomentUtils} locale={locale}>
                                    <DatePicker required
                                     style={{ width: '100%' }}
                                     onChange={(date) => this.handleChange("toDate", date)}
                                     margin="none"
                                     name="toDate"
                                     emptyLabel="(последният ден, в който не сте на работа)"
                                     label="Крайна дата"
                                     value={this.state.toDate}
                                     format={'DD.MM.YYYY'}
                                     minDate={this.state.fromDate === null?'':this.state.fromDate}
                                     disabled={this.state.toDateButton}
                                     clearable={true}
                                     clearLabel='Изчисти'
                                     cancelLabel='Назад'
                                     okLabel='Избери'
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            {this.state.daysBrake !== 0 && this.state.daysBrakeError === '' ?
                                <Grid item xs={12} sm={12}>
                                    <Typography component="h4" variant="h6" align="left" className="days-brake">
                                        Общо работни дни за болничен: {this.state.daysBrake}
                                    </Typography>
                                </Grid> : null}
                            <Grid item xs={12} sm={12}>
                                <TextField
                                    id="desc"
                                    name="desc"
                                    label="Описание"
                                    fullWidth
                                    autoComplete="billing address-level2"
                                    value={this.state.desc}
                                    onChange={(e) => this.handleChangeSelect("desc", e)}
                                />
                            </Grid>
                        </Grid>
                        <div className={classes.buttons}>
                            {this.state.validHealthBrake ?
                                <span>
                                    <Button
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        className={classes.buttonSuccess}
                                        disabled={this.state.btnDisabled}
                                        onClick={this.submitHealthForm}
                                    >
                                      <Save className='white-back-button customBtn'></Save>
                                    <span className='btn-content'>  Запис </span>
                    </Button>
                                </span> : null}
                                <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={() => { this.redirectToHolidaysList() }}
                            className={classes.buttonBack}
                        >
                            <ArrowBackIos className='white-back-button customBtn'></ArrowBackIos>
                            Назад
                         </Button>
                        </div>
                    </span>}

            </React.Fragment>
        );
    }
}
AddressForm.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(withSnackbar(AddressForm));
